// extracted by mini-css-extract-plugin
module.exports = {"pokegrid":"grid_pokegrid__MlkMt","link":"grid_link__2zXDC","names":"grid_names__3MEOL"};